import * as React from "react";
import { useContext } from "react";

interface ScreenSizeContextType {
  isTabletLandscapeUp: boolean;
  isDesktop: boolean;
  isPhone: boolean;
}

export const ScreenSizeContext = React.createContext<ScreenSizeContextType>({
  isTabletLandscapeUp: false,
  isDesktop: false,
  isPhone: false,
});
export const useScreenSize = (): ScreenSizeContextType =>
  useContext(ScreenSizeContext);
